import { pixelEventFields } from '../pixelAuditLinkFormat';

export function transformWeboramaUrl(url: string, name: string): string {
  let transformedUrl = url.trim();

  // Определяем тип поля
  const isPixel = [
    'click_audit_pixel',
    'pixel',
    'pixel_additional',
    'pixel_additional2',
  ].includes(name);
  const isLink = name === 'link';

  // Проверяем, является ли это ссылкой Weborama
  const isWeborama = url.includes('wcm-ru.');

  // Если не Weborama ссылка - возвращаем как есть
  if (!isWeborama) {
    return transformedUrl;
  }

  // Для link поля - обрабатываем ссылки перехода
  if (isLink) {
    // Проверяем, что это ссылка перехода (a.A=cl)
    if (!transformedUrl.includes('a.A=cl')) {
      return transformedUrl; // Не link перехода
    }

    // 1. g.lu= с пустым значением оставляем как есть (ничего не делаем)

    // 2. Заменяем a.ra на a.ra={RND}
    transformedUrl = transformedUrl.replace(/a\.ra=[^&]*/g, 'a.ra={RND}');

    // 3. Дописываем параметры, если их нет
    const paramsToAdd = [
      { name: 'a.ycp', value: '{TR_KEY}' },
      { name: 'er', value: '1' },
      { name: 'erid', value: '{ERID}' },
    ];

    paramsToAdd.forEach(({ name: paramName, value }) => {
      if (!transformedUrl.includes(`${paramName}=`)) {
        const separator = transformedUrl.includes('?') ? '&' : '?';
        transformedUrl += `${separator}${paramName}=${value}`;
      }
    });
  }

  // Для pixel полей - обрабатываем пиксели аудита
  if (isPixel) {
    // Проверяем, что это пиксель аудита (a.A=im)
    if (!transformedUrl.includes('a.A=im')) {
      return transformedUrl; // Не pixel аудита
    }

    // Заменяем a.ra на a.ra={RND}
    transformedUrl = transformedUrl.replace(/a\.ra=[^&]*/g, 'a.ra={RND}');
  }

  // Для других полей (не link и не pixel) - возвращаем как есть
  if (!isLink && !isPixel) {
    return transformedUrl;
  }

  return transformedUrl;
}

export function transformWeboramaVastUrl(url: string, name: string): string {
  if (name !== 'data.vast_url') {
    return url;
  }

  if (!url.includes('wcm-ru.')) {
    return url;
  }

  try {
    const [base, query = ''] = url.split('?');
    if (!query) return url;

    // Создаем объект для параметров
    const paramsObj: Record<string, string> = {};

    // Заполняем параметры
    query.split('&').forEach((param) => {
      const [key, value = ''] = param.split('=');
      paramsObj[key] = value;
    });

    // 1. Обновляем a.ra
    if (paramsObj['a.ra']) {
      paramsObj['a.ra'] = '{RND}';
    }

    // 2. Обновляем a.ycp
    if (paramsObj['a.ycp']) {
      const currentYcp = paramsObj['a.ycp'];

      if (currentYcp.includes('{TR_KEY}')) {
        if (!currentYcp.includes('%7Cse%3A1')) {
          paramsObj['a.ycp'] = `${currentYcp}%7Cse%3A1`;
        }
      } else {
        paramsObj['a.ycp'] = '{TR_KEY}%7Cse%3A1';
      }
    }

    // 3. Добавляем er=1
    if (!paramsObj.er) {
      paramsObj.er = '1';
    }

    // Обновляем erid
    if (paramsObj.erid === '[ERID]') {
      paramsObj.erid = '{ERID}';
    }

    // Собираем обратно
    const queryString = Object.entries(paramsObj)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');

    return `${base}?${queryString}`;
  } catch (error) {
    console.error('Error transforming Weborama VAST URL:', error);
    return url;
  }
}

export function transformWeboramaEventPixelUrl(
  url: string,
  name: string,
): string {
  if (!pixelEventFields.includes(name)) {
    return url;
  }

  // Проверяем, содержит ли код ссылку wcm-ru.
  if (!url.includes('wcm-ru.')) {
    return url;
  }

  // Простая замена ~RANDOM~ на {RND}
  return url
    .replace(/g\.ra=~RANDOM~/g, 'g.ra={RND}')
    .replace(/g\.ra=\[RANDOM\]/g, 'g.ra={RND}')
    .replace(/g\.ra=RANDOM/g, 'g.ra={RND}');
}
